import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import LocalizacaoView from './DefaultView';

const LocalizacaoBlockView = (props) => {
  return <LocalizacaoView {...props} />;
};

export default withBlockExtensions(LocalizacaoBlockView);
